import { useMutation, useQueryClient } from 'react-query';
import { phoneQueryKeys } from '../queries/queryKeys';
import request from '../../../helpers/request';

const clearListAnsweredCalls = async () => {
  return await request.delete(
    '/Phone/clear_list_not_answered_calls',
    null,
    'При очистке списка непринятых звонков произошла ошибка.'
  );
};

const useClearListAnsweredCalls = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(clearListAnsweredCalls, {
    onSuccess: () => queryClient.invalidateQueries(phoneQueryKeys.calls()),
  });

  return {
    clearAsync: mutation.mutateAsync,
    loading: mutation.isLoading,
  };
};

export default useClearListAnsweredCalls;
